import React from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Alert, Button, Typography } from '@mui/material';
import AuthShell from './AuthShell';

const MESSAGES = {
  '403': {
    title: 'Not registered for this application',
    body: 'Your Bernardo SSO account is not on this app yet. Ask an admin to add you from Manage Users.',
  },
  '409': {
    title: 'Identity does not match this account',
    body: 'This SSO identity is already tied to a different local user. Contact an admin.',
  },
  authentik: {
    title: 'Sign-in was cancelled or failed',
    body: 'Authentik returned an error. You can try again from the sign-in page.',
  },
  missing_code: {
    title: 'Sign-in could not be completed',
    body: 'The callback was missing a code. Start again from the sign-in page.',
  },
  exchange: {
    title: 'Sign-in could not be completed',
    body: 'The app could not finish exchanging your sign-in code. Try again.',
  },
};

export default function AuthError() {
  const [params] = useSearchParams();
  const reason = params.get('reason') || 'exchange';
  const extra = params.get('detail') || '';
  const msg = MESSAGES[reason] || MESSAGES.exchange;

  return (
    <AuthShell subtitle="Sign-in problem">
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography sx={{ fontWeight: 700, mb: 0.5 }}>{msg.title}</Typography>
        <Typography sx={{ fontSize: '0.875rem' }}>{msg.body}</Typography>
        {extra && (
          <Typography sx={{ fontSize: '0.75rem', mt: 1, opacity: 0.85 }}>{extra}</Typography>
        )}
      </Alert>
      <Button component={RouterLink} to="/auth/login" variant="contained" fullWidth>
        Back to sign in
      </Button>
    </AuthShell>
  );
}